module.exports = function(service) {
	service 
  .factory("putDataService", putDataService);
  putDataService.$inject = ['$resource','API_URL'];
  function putDataService($resource, API_URL) {
    var data = $resource(API_URL+ ":param1/:param2/:param3/:param4", {param1:"@param1", param2:'@param2',param3:'@param3', param4:"@param4"} ,{
       
          update:{
            method:'PUT'
         }
      })
    // ).update(
    //   {},
    //     <BODY_OBJECT>,
    //     function (successResponse) {},
    //     function (failResponse) {}
    // );
    return data;
  }
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/putDataService.js
// module id = 621
// module chunks = 0